export default (val) => Object.prototype.toString.call(val).match(/\s(\w+)/)[1];
